import { SURFACE_BORDER, ACCENT } from '../designsystem/tokens';

export const OBJECT_TYPES = ['contact', 'company', 'deal', 'task', 'meeting', 'note', 'mail', 'call'];

export const TYPE_COLORS = {
    string: '#4FC3F7',
    number: '#81C784',
    date: '#FFB74D',
    datetime: '#FFB74D',
    enumeration: '#CE93D8',
    bool: '#A5D6A7',
    phone_number: '#4FC3F7',
};

export const inputSx = {
    '& .MuiOutlinedInput-root': {
        color: 'white',
        '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
        '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.4)' },
        '&.Mui-focused fieldset': { borderColor: ACCENT },
    },
    '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.38)' },
    '& .MuiInputLabel-root.Mui-focused': { color: ACCENT },
};

export const darkPopperProps = {
    popper: { sx: { zIndex: 1400 } },
    paper: {
        sx: {
            backgroundColor: 'rgba(30,35,50,0.98)',
            backdropFilter: 'blur(16px)',
            color: 'white',
            borderRadius: '12px',
            border: `1px solid ${SURFACE_BORDER}`,
            mt: 0.5,
            '& .MuiAutocomplete-option': {
                '&:hover': { backgroundColor: 'rgba(118,169,172,0.15)' },
                '&[aria-selected="true"]': { backgroundColor: 'rgba(118,169,172,0.25)' },
            },
        },
    },
};

export const selectMenuProps = {
    PaperProps: {
        sx: {
            backgroundColor: 'rgba(30,35,50,0.98)',
            backdropFilter: 'blur(16px)',
            color: 'white',
            borderRadius: '10px',
            border: `1px solid ${SURFACE_BORDER}`,
            '& .MuiMenuItem-root:hover': { backgroundColor: 'rgba(118,169,172,0.15)' },
        },
    },
};

/** Normalize saved properties that may be in legacy string-only format */
export function normalizeSavedProps(savedProps, allProps) {
    const safeSavedProps = Array.isArray(savedProps) ? savedProps : [];
    const safeAllProps = Array.isArray(allProps) ? allProps : [];

    return safeSavedProps
        .filter((p) => typeof p === 'string' || (p && typeof p === 'object' && typeof p.name === 'string'))
        .map(p => {
        const propName = typeof p === 'string' ? p : p.name;
        const originalProp = safeAllProps.find(rp => rp?.name === propName);
        if (typeof p === 'string') {
            return { name: p, label: originalProp?.label || p, mandatory: false, mandatoryIf: '', type: originalProp?.type || '' };
        }
        return { ...p, label: originalProp?.label || p.name, type: p.type || originalProp?.type || '' };
    });
}
